import { useEffect, useState } from 'react';
//import { useCamera } from "@ionic/react-hooks/camera";
import { useCamera, availableFeatures } from '@capacitor-community/react-hooks/camera';
import { CameraResultType, CameraSource, CameraPhoto, Capacitor, FilesystemDirectory, } from "@capacitor/core";

/* Global State*/ 


import c from "../utils/common";
import moment from "moment-timezone";
import axios from 'axios';
let globalState = undefined;
export function usePhoto() {
  const { getPhoto } = useCamera();

  const takePhoto = async () => {
    //console.log("takePhoto...")
    const cameraPhoto = await getPhoto({
      resultType: CameraResultType.Uri,
      source: CameraSource.Prompt,
      quality: 100,
      //allowEditing: true,
      promptLabelPhoto: "取自相簿",
      promptLabelPicture: '拍照',
    });
    let path = cameraPhoto.webPath;
    //console.log(path);
    return path;
  };
  return { takePhoto };
};
